import styled from 'styled-components';
import Icon from 'js/components/common/Icon';

export default styled(Icon)`
  align-self: center;
  justify-self: center;
  font-size: 2rem;
  margin: 0 0.75rem 1rem;
`;
